import { useParams } from 'react-router-dom'

import { UserGroupsPanel } from '../components/UserGroupsPanel'

export const WorkspaceGroupsPage = () => {
  const { id: idParam } = useParams<{ id: string }>()
  const workspaceId = Number(idParam)

  if (!Number.isFinite(workspaceId) || workspaceId <= 0) return null

  return <UserGroupsPanel workspaceId={workspaceId} />
}
